define([
  '../../global/router',
  'jquery',
  './view'
], (router, $, View) => {
  let lastWindowWidth = window.innerWidth;
  const $widgets = $('.hh-widget.hh-widget-availability');

  if ($widgets.length === 0) {
    return;
  }

  const views = [];
  $widgets.each(function each() {
    const view = new View({
      el: $(this)
    });
    view.render();
    views.push(view);
  });

  router.route('type/:number(/:number)', 'type', (typeId, webProductId) => {
    views.forEach((view) => {
      if (!view.enableNavigation) {
        return;
      }

      view.data.type = parseInt(typeId, 10);
      if (webProductId) {
        view.data.id = parseInt(webProductId, 10);
      }
      view.render();
    });
  });

  function shouldWidgetRerender() {
    const currentWindowWidth = window.innerWidth;

    if (
      (currentWindowWidth >= 768 && lastWindowWidth < 768) ||
      (currentWindowWidth < 768 && lastWindowWidth >= 768)
    ) {
      views.forEach(view => {
        view.renderWebProductInfo();
      });
    }
    lastWindowWidth = currentWindowWidth;
  }

  $(window).on("resize", shouldWidgetRerender);
});
